export default __webpack_public_path__ + "static/media/businessPremisesImg.60ebe435.svg";